var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentComponent)?_c(_vm.currentComponent,{tag:"component",attrs:{"block-info":_vm.blockInfo,"blockDataInfo":_vm.blockDataInfo,"showTop":_vm.showTop,"topValue":_vm.topValue},on:{"clickItem":_vm.clickItem}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }